import { Fragment } from "react";

function ServiceCoverageMatrix({ serviceLabel, sideLabel, columns, rows, className = "" }) {
  const classes = ["public-coverage-matrix__frame", className].filter(Boolean).join(" ");
  const matrixStyle = { "--coverage-module-count": String(columns.length) };
  const railStyle = { gridRow: `1 / span ${rows.length + 1}` };

  return (
    <div className={classes}>
      <div className="public-coverage-matrix__scroll">
        <div className="public-coverage-matrix" style={matrixStyle}>
          <div className="public-coverage-matrix__rail" style={railStyle} aria-hidden="true">
            <span className="public-coverage-matrix__rail-label">{sideLabel}</span>
          </div>

          <div className="public-coverage-matrix__service">{serviceLabel}</div>

          {columns.map((column, columnIndex) => (
            <div
              key={column.key}
              className={[
                "public-coverage-matrix__column",
                columnIndex === columns.length - 1 ? "public-coverage-matrix__column--last" : ""
              ].filter(Boolean).join(" ")}
            >
              {column.label}
            </div>
          ))}

          {rows.map((row) => (
            <Fragment key={row.label}>
              <div className="public-coverage-matrix__row-label">{row.label}</div>

              {columns.map((column, columnIndex) => {
                const isCovered = row.coverage.includes(column.key);
                const isBottomRightCorner =
                  row.label === rows[rows.length - 1].label && columnIndex === columns.length - 1;

                return (
                  <div
                    key={`${row.label}-${column.key}`}
                    className={[
                      "public-coverage-matrix__cell",
                      isBottomRightCorner ? "public-coverage-matrix__cell--last" : ""
                    ].filter(Boolean).join(" ")}
                    aria-label={isCovered ? `${row.label}: inkluderet i ${column.label}` : undefined}
                  >
                    {isCovered ? <span className="public-coverage-matrix__dot" aria-hidden="true" /> : null}
                  </div>
                );
              })}
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ServiceCoverageMatrix;
